export default __webpack_public_path__ + "img/app-page/screen1Android.0eb186bf4ab2442b1e94fe47c2026f63.png";